export const calculateNextRowsLength = (page: number, count: number, rowsPerPage: number, lastPage: number) => {
  if (lastPage != null && page + 1 >= lastPage) {
    const itemsLength = (page + 1) * rowsPerPage;
    return count - itemsLength;
  }
  return rowsPerPage;
};

export const calculateLastPage = (count: number, rowsPerPage: number) => {
  return Math.max(0, Math.ceil(count / rowsPerPage) - 1);
};
